import React from 'react';
import '../cta-feature/ctaFeature.scss';
import { Text } from 'prixa-design-kit/dist';

const diagnoseEngineImg = `${process.env.REACT_APP_ASSET_URL}/home/Menu Sistem Periksa.png`;
const consultationViaChatImg = `${process.env.REACT_APP_ASSET_URL}/home/Menu Konsultasi.png`;
const doctorAppointmentImg = `${process.env.REACT_APP_ASSET_URL}/home/Menu Janji Temu.png`;
const drugDeliveryImg = `${process.env.REACT_APP_ASSET_URL}/home/Menu Antar Farmasi.png`;
const labTestImg = `${process.env.REACT_APP_ASSET_URL}/home/Menu Tes Lab.png`;

interface CtaFeatureProps {
  isTitle?: boolean;
  isShowDiagnonseMenu?: boolean;
}

const CTAContent = [
  {
    text: 'Konsultasi via Chat',
    enabled: process.env.REACT_APP_TELEMED_ON === 'true' ? true : false,
    link: '/initiate',
    newTab: false,
    img: consultationViaChatImg,
  },
  {
    text: 'Janji Temu Dokter',
    enabled: process.env.REACT_APP_APPOINTMENT_ON === 'true' ? true : false,
    link: '',
    newTab: false,
    img: doctorAppointmentImg,
  },
  {
    text: 'Pesan Antar Farmasi',
    enabled: process.env.REACT_APP_LAB_ON === 'true' ? true : false,
    link: 'https://www.farmaku.com/',
    newTab: true,
    img: drugDeliveryImg,
  },
  {
    text: 'Tes Lab',
    enabled: process.env.REACT_APP_PHARMACY_ON === 'true' ? true : false,
    link: 'https://www.triasse.com/',
    newTab: true,
    img: labTestImg,
  },
];

const CtaFeature = ({ isTitle = true, isShowDiagnonseMenu = false }: CtaFeatureProps) => {
  return (
    <div className="prixa-container text-center">
      <CTATitle isTitle={isTitle} />
      <CTADiagnose isShowDiagnonseMenu={isShowDiagnonseMenu} />
      {CTAContent.map((data, i) => {
        if ((i + 1) % 2 === 1) {
          return (
            <div className="prixa-cta" key={i}>
              <CTAContentBlocks
                text={data.text}
                enabled={data.enabled}
                link={data.link}
                newTab={data.newTab}
                img={data.img}
              />
              <CTAContentBlocks
                text={CTAContent[i + 1].text}
                enabled={CTAContent[i + 1].enabled}
                link={CTAContent[i + 1].link}
                newTab={CTAContent[i + 1].newTab}
                img={CTAContent[i + 1].img}
              />
            </div>
          );
        } else {
          return <span key={i} />;
        }
      })}
    </div>
  );
};

const CTAContentBlocks = ({ text, enabled, link, newTab, img }: any) => {
  const imagePlate = (
    <React.Fragment>
      <img loading="lazy" width="140px" height="140px" alt="Drug Delivery" src={img} />
      {enabled ? (
        <span />
      ) : (
        <React.Fragment>
          <div className="prixa-cta-soon"></div>
          <span className="coming-soon">Segera Hadir</span>
        </React.Fragment>
      )}
      <div className="prixa-cta-title">
        <span>{text}</span>
      </div>
    </React.Fragment>
  );
  if (enabled) {
    return (
      <a target={newTab ? '_blank' : '_self'} rel="noopener noreferrer" href={link} className="cta">
        {imagePlate}
      </a>
    );
  } else {
    return <div className="cta">{imagePlate}</div>;
  }
};

const CTATitle = ({ isTitle }: any) => {
  if (isTitle) {
    return (
      <div className="margin-largeB">
        <Text scale="headerTitle">
          Perlu penanganan lebih lanjut untuk keluhan Anda? <br /> Prixa siap membantu.
        </Text>
      </div>
    );
  } else return null;
};

const CTADiagnose = ({ isShowDiagnonseMenu }: any) => {
  if (isShowDiagnonseMenu) {
    return (
      <div className="prixa-cta">
        <a href="/" className="cta">
          <img loading="lazy" width="100%" alt="Diagnose Engine" src={diagnoseEngineImg} />
          <div className="prixa-cta-title">
            <span>Periksa Gejala</span>
          </div>
        </a>
      </div>
    );
  } else return null;
};

export default CtaFeature;
